import { motion, AnimatePresence, useReducedMotion } from "framer-motion"

type HomeCarouselIllustrationProps = {
	slideIndex: number
}

export const HomeCarouselIllustration: React.FC<HomeCarouselIllustrationProps> = ({
	slideIndex,
}) => {
	const shouldReduceMotion = useReducedMotion()

	const mainUrl =
		process.env.REACT_APP_MODE === "production"
			? `${window.location.origin}`
			: `${process.env.PUBLIC_URL}`

	return (
		<AnimatePresence>
			<motion.img
				src={`${mainUrl}/images/Chevalier_${slideIndex}.png`}
				alt=""
				width="410"
				className="hidden lg:block absolute top-0 right-0"
				key={slideIndex}
				initial={shouldReduceMotion ? {} : { scale: 0.8, opacity: 0 }}
				animate={{ scale: 1, opacity: 1 }}
				exit={shouldReduceMotion ? {} : { scale: 0, opacity: 0 }}
			/>
		</AnimatePresence>
	)
}
